export default __webpack_public_path__ + "static/media/Shoes4.26cbc55f.png";